import Grid2 from "@mui/material/Grid2";

import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { RollOperation } from "../../models/Operation";
import { getRollOperations } from "../../repositories/OperationRepository";
import { TableOperation } from "./components/TableOperation";

export const useOperations = (onError?: (error: Error) => void) => {
	return useQuery<RollOperation[], Error>({
		queryKey: ["operations"],
		queryFn: ({ signal }) => getRollOperations({}, signal),
		onError: onError,
	});
};

export const OperationPage = () => {
	const { partId } = useParams();

	return (
		<>
			<Grid2 container justifyContent="center" alignItems="center">
				<Grid2 size={{ md: 12, xs: 12 }} style={{ margin: 0, marginTop: 10 }}>
					<TableOperation partId={partId} />
				</Grid2>
			</Grid2>
		</>
	);
};
